import { render, staticRenderFns } from "./MenuTabActions.vue?vue&type=template&id=33aff615&scoped=true"
import script from "./MenuTabActions.vue?vue&type=script&lang=js"
export * from "./MenuTabActions.vue?vue&type=script&lang=js"
import style0 from "./MenuTabActions.vue?vue&type=style&index=0&id=33aff615&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aff615",
  null
  
)

export default component.exports